"use client";

import { useRef, useState } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";

import {
  ViabilityCalculatorPremium,
  type ViabilityCalculatorProps,
} from "@/app/_components/viability-calculator/viability-calculator";
import { Error } from "@/app/_components/error";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { ViabilityListLoading } from "./loading";

import { formatBRL } from "@/helper/currency";

import { newId } from "@/constants";

import { useViabilities } from "@/queries/use-viabilities";

export const ViabilityList = (props: ViabilityCalculatorProps) => {
  const listRef = useRef<HTMLDivElement>(null);
  const { data, isFetching, error, refetch } = useViabilities({
    hasPaidPlan: props.hasPaidPlan,
    id: props.data?.leilao_id,
  });
  const [selectedViabilityId, setSelectedViabilityId] = useState<string | null>(
    null
  );

  const onBack = () => {
    setSelectedViabilityId(null);
    props.onBack?.();
  };

  const onSave = () => {
    setSelectedViabilityId(null);
    props.onSave?.();
  };

  if (isFetching) return <ViabilityListLoading />;

  if (error) return <Error reset={refetch} />;

  const hasViabilities = data && data.length > 0;

  if (!hasViabilities || selectedViabilityId) {
    return (
      <ViabilityCalculatorPremium
        hideShare
        {...(selectedViabilityId
          ? { id: selectedViabilityId, ...props }
          : props)}
        onBack={hasViabilities ? onBack : undefined}
        onSave={onSave}
      />
    );
  }

  return (
    <div className="flex flex-col gap-6 scroll-mt-36" ref={listRef}>
      <div className="flex items-center justify-end">
        <Button
          onClick={() => {
            setSelectedViabilityId(newId);
          }}
        >
          <PlusIcon className="size-4 mr-2" aria-hidden="true" />
          Novo cálculo
        </Button>
      </div>
      {data?.map((viability) => (
        <button
          key={viability.id}
          type="button"
          className="text-left"
          onClick={() => {
            setSelectedViabilityId(viability.id);
          }}
        >
          <Card className="h-full cursor-pointer hover:bg-gray-50">
            <CardHeader>
              <CardTitle>{viability.titulo}</CardTitle>
              <CardDescription>
                Lucro estimado: {formatBRL(viability.lucro_estimado)}
              </CardDescription>
            </CardHeader>
          </Card>
        </button>
      ))}
    </div>
  );
};
